"use client";

import React from "react";
import styled from "styled-components";
import { spacing4, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
import { InternalUseOnlyActionable } from "./Actionable";
import { InternalUseOnlyDismissible } from "./Dismissible";
import { Content } from "./sharedStyles";
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  componentId: "sc-2jng2r-0"
})(["display:inline-flex;&& ", "{padding-inline-end:", ";border-inline-end:1px solid;margin:0;border-top-right-radius:0;border-bottom-right-radius:0;order:1;", "}&& ", "{border-inline-start:none;padding-inline-start:", ";padding-inline-end:", ";margin:0;border-top-left-radius:0;border-bottom-left-radius:0;order:2;", " & ", "{clip:rect(0 0 0 0);clip-path:inset(100%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;}}"], InternalUseOnlyActionable, spacing8, dir("rtl")`
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 0.9375rem;
      border-bottom-right-radius: 0.9375rem;
    `, InternalUseOnlyDismissible, spacing4, spacing8, dir("rtl")`
      border-top-left-radius: 0.9375rem;
      border-bottom-left-radius: 0.9375rem;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `, Content);

/**
 * A wrapper for `Actionable` and `Dismissible` when you want a single tag that can do both.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Must be an `<Actionable>` element as the first child and a `<Dismissible>` element as the second child.
 * @returns {React.ReactElement} The `Combo` component
 */
const Combo = ({
  children,
  ...props
} = {}) => {
  return /*#__PURE__*/_jsx(Wrapper, {
    ...props,
    children: children
  });
};
Combo.displayName = "Combo";
export default Combo;